import React from "react";
import "./AboutIntro.css";
import { useTranslation } from "react-i18next";

// Helper function to highlight key terms in text
const highlightText = (text, isArabic = false) => {
  // Key terms to highlight (English and Arabic)
  const highlightTerms = isArabic
    ? [
        // Arabic terms
        { pattern: /ستارغيت ش\.م\.م\.|ستارغيت|ستار غيت/gi, className: "text-highlight" },
        { pattern: /لبنان/gi, className: "text-highlight" },
        { pattern: /التأمين/gi, className: "text-highlight" },
        { pattern: /الوساطة/gi, className: "text-highlight" },
        { pattern: /الاستشارات/gi, className: "text-highlight" },
      ]
    : [
        // English terms
        { pattern: /Lebanon/gi, className: "text-highlight" },
        { pattern: /insurance/gi, className: "text-highlight" },
        { pattern: /brokerage/gi, className: "text-highlight" },
        { pattern: /consultancy/gi, className: "text-highlight" },
        { pattern: /professional/gi, className: "text-highlight" },
        { pattern: /partnerships/gi, className: "text-highlight" },
        { pattern: /solutions/gi, className: "text-highlight" },
      ];

  // Find all matches with their positions
  const matches = [];
  highlightTerms.forEach(({ pattern, className }) => {
    const regex = new RegExp(pattern.source, pattern.flags);
    let match;
    while ((match = regex.exec(text)) !== null) {
      matches.push({
        start: match.index,
        end: match.index + match[0].length,
        text: match[0],
        className,
      });
    }
  });

  // Sort matches by start position
  matches.sort((a, b) => a.start - b.start);

  const parts = [];
  let lastIndex = 0;

  matches.forEach((match) => {
    // Add text before the highlight
    if (match.start > lastIndex) {
      parts.push({ text: text.substring(lastIndex, match.start), highlight: false });
    }
    // Add the highlighted text
    parts.push({ text: match.text, highlight: true, className: match.className });
    lastIndex = match.end;
  });

  // Add any remaining text after the last highlight
  if (lastIndex < text.length) {
    parts.push({ text: text.substring(lastIndex), highlight: false });
  }

  return parts.length > 0 ? parts : [{ text, highlight: false }];
};

const AboutIntro = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const missionText = t("about.mission.text");
  const parts = highlightText(missionText, isArabic);

  return (
    <section className="about-intro section section--full">
      <div className="about-inner container">
        <div className="about-columns">
          <div className="about-text hidden">
            <h2>{t("about.mission.title")}</h2>
            <p>
              {parts.map((part, partIdx) =>
                part.highlight ? (
                  <mark key={partIdx} className={part.className}>
                    {part.text}
                  </mark>
                ) : (
                  <React.Fragment key={partIdx}>{part.text}</React.Fragment>
                )
              )}
            </p>
            <a className="btn light" href="/about">
              {t("about.intro.learnMore")}
            </a>
          </div>
          <div className="about-visual hidden">
            <img
              src="https://i.ibb.co/sQWZGz2/vision.jpg"
              alt={t("about.mission.title")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutIntro;
